import axios from 'axios';
import { IUser, IUserWithSessions } from '../types/User';

export interface IUserService {
    fetchAllUsersWithSessions(
        skipSessions: number,
        limit: number,
    ): Promise<IUserWithSessions[]>;
    fetchUsers(skipSessions: number, limit: number): Promise<IUser[]>;
}

class UserService implements IUserService {
    async fetchAllUsersWithSessions(
        skipSessions: number,
        limit: number,
    ): Promise<IUserWithSessions[]> {
        const usersWithSessionsResponse = await axios.get<IUserWithSessions[]>(
            `/users/getAllUsersAndSessions/${skipSessions}/${limit}`,
        );
        return usersWithSessionsResponse.data;
    }

    async fetchUsers(skipSessions: number, limit: number): Promise<IUser[]> {
        const usersResponse = await axios.get<IUser[]>(
            `/users/${skipSessions}/${limit}`,
        );
        return usersResponse.data;
    }

    async fetchValidUsers(
        skipSessions: number,
        limit: number,
    ): Promise<IUser[]> {
        const usersResponse = await axios.get<IUser[]>(
            `/validUsers/${skipSessions}/${limit}`,
        );
        return usersResponse.data;
    }

    async fetchInvalidUsers(
        skipSessions: number,
        limit: number,
    ): Promise<IUser[]> {
        const usersResponse = await axios.get<IUser[]>(
            `/invalidUsers/${skipSessions}/${limit}`,
        );
        return usersResponse.data;
    }
}

const UserServiceInstance = new UserService();

export default UserServiceInstance;
